module.exports = "/packs/media/images/growth1-5bd41f13ed30dd57d6226a7564f96995.jpg";